module.exports = __webpack_public_path__ + "img/kkhz_code.42672be9.jpg";